
import { motion } from "framer-motion";
import { Truck, Clock, MapPin } from "lucide-react";

export default function ShippingPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow pt-24 pb-24">
        <div className="container mx-auto px-4 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold font-playfair mb-8">Shipping and Delivery</h1>
            <div className="prose max-w-none space-y-6 text-gray-700">
              <p>
                We offer multiple shipping options to ensure your jewellery reaches you safely and on time.
              </p>
              <div className="grid md:grid-cols-3 gap-6 my-8">
                <div className="bg-purple-50 rounded-lg p-6">
                  <Truck className="w-8 h-8 text-purple-600 mb-4" />
                  <h3 className="font-bold text-lg mb-2">Free Shipping</h3>
                  <p className="text-sm">On prepaid orders above ₹500</p>
                </div>
                <div className="bg-pink-50 rounded-lg p-6">
                  <Clock className="w-8 h-8 text-pink-600 mb-4" />
                  <h3 className="font-bold text-lg mb-2">Express Delivery</h3>
                  <p className="text-sm">24-hour delivery in Mumbai (charges apply)</p>
                </div>
                <div className="bg-blue-50 rounded-lg p-6">
                  <MapPin className="w-8 h-8 text-blue-600 mb-4" />
                  <h3 className="font-bold text-lg mb-2">Standard Delivery</h3>
                  <p className="text-sm">3-5 business days nationwide</p>
                </div>
              </div>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Shipping Methods</h2>
              <ul className="list-disc list-inside space-y-2">
                <li><strong>Standard Shipping:</strong> 3-5 business days (Free on orders above ₹500)</li>
                <li><strong>Express Shipping:</strong> 24-hour delivery available in Mumbai (Additional charges apply)</li>
                <li><strong>Cash on Delivery:</strong> Available for orders above ₹500</li>
              </ul>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Shipping Charges</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Orders above ₹500: Free shipping</li>
                <li>Orders below ₹500: ₹100 shipping charges</li>
                <li>Express delivery: Additional ₹200</li>
              </ul>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Tracking Your Order</h2>
              <p>
                Once your order is shipped, you will receive a tracking number via email and SMS. You can
                track your order status in real-time.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Delivery Areas</h2>
              <p>We currently deliver to all major cities and towns across India.</p>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
